import { render, staticRenderFns } from "./v-tag-input.vue?vue&type=template&id=a051806c&"
import script from "./v-tag-input.vue?vue&type=script&lang=js&"
export * from "./v-tag-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports